import { __extends } from 'tslib';
import { UserManager } from 'oidc-client';
import { from } from 'rxjs';
import { fromPromise } from 'rxjs-compat/observable/fromPromise';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule, MatCardModule } from '@angular/material';
import { Injectable, Component, Input, defineInjectable, NgModule, inject } from '@angular/core';
import { Router } from '@angular/router';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/oauth-lib-configurations.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// Configuration interface
var  
// Configuration interface
OauthLibConfiguration = /** @class */ (function () {
    function OauthLibConfiguration() {
    }
    return OauthLibConfiguration;
}());
/**
 * @abstract
 */
var OauthConfigurationProvider = /** @class */ (function () {
    function OauthConfigurationProvider() {
    }
    OauthConfigurationProvider.decorators = [
        { type: Injectable, args: [{ providedIn: 'root' },] }
    ];
    /** @nocollapse */ OauthConfigurationProvider.ngInjectableDef = defineInjectable({ factory: function OauthConfigurationProvider_Factory() { return new OauthConfigurationProvider(); }, token: OauthConfigurationProvider, providedIn: "root" });
    return OauthConfigurationProvider;
}());
// Fallback
var DefaultOauthConfiguration = /** @class */ (function (_super) {
    __extends(DefaultOauthConfiguration, _super);
    function DefaultOauthConfiguration() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(DefaultOauthConfiguration.prototype, "config", {
        get: /**
         * @return {?}
         */
        function () {
            return {
                oicdClient: {
                    authority: '',
                    client_id: '',
                    redirect_uri: '/',
                    response_type: '',
                    scope: ''
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    DefaultOauthConfiguration.decorators = [
        { type: Injectable, args: [{ providedIn: 'root' },] }
    ];
    /** @nocollapse */ DefaultOauthConfiguration.ngInjectableDef = defineInjectable({ factory: function DefaultOauthConfiguration_Factory() { return new DefaultOauthConfiguration(); }, token: DefaultOauthConfiguration, providedIn: "root" });
    return DefaultOauthConfiguration;
}(OauthConfigurationProvider));
var OauthConfiguration = /** @class */ (function () {
    function OauthConfiguration() {
    }
    return OauthConfiguration;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/oauth-lib.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var OauthLibService = /** @class */ (function () {
    function OauthLibService(oauthConfigurationProvider) {
        this.oauthConfigurationProvider = oauthConfigurationProvider;
        /** @type {?} */
        var oicdClientSettings = this.oauthConfigurationProvider.config.oicdClient;
        this.loginWithRoles = this.oauthConfigurationProvider.config.loginWithRoles;
        this.userManager = new UserManager(oicdClientSettings);
    }
    /**
     *
     */
    /**
     *
     * @return {?}
     */
    OauthLibService.prototype.startAuthentication = /**
     *
     * @return {?}
     */
    function () {
        return this.userManager.signinRedirect();
    };
    /**
     *
     * @param oicdConfiguration
     */
    /**
     *
     * @return {?}
     */
    OauthLibService.prototype.completeAuthentication = /**
     *
     * @return {?}
     */
    function () {
        // Create observable from oicd-client callback
        return from(this.userManager.signinRedirectCallback());
    };
    /**
     *
     * @param loginUserRoles
     */
    /**
     *
     * @param {?} loginUserRoles
     * @return {?}
     */
    OauthLibService.prototype.canLoginWithRoles = /**
     *
     * @param {?} loginUserRoles
     * @return {?}
     */
    function (loginUserRoles) {
        if (!this.loginWithRoles) {
            console.warn('OauthLibService: No white list provided. Allowing access');
            return true;
        }
        for (var i = 0; i < loginUserRoles.length; i++) {
            if (this.loginWithRoles.includes(loginUserRoles[i])) {
                return true;
            }
        }
        return false;
    };
    /**
     *
     */
    /**
     *
     * @return {?}
     */
    OauthLibService.prototype.getUser$ = /**
     *
     * @return {?}
     */
    function () {
        return fromPromise(this.userManager.getUser());
    };
    OauthLibService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    OauthLibService.ctorParameters = function () { return [
        { type: OauthConfigurationProvider }
    ]; };
    /** @nocollapse */ OauthLibService.ngInjectableDef = defineInjectable({ factory: function OauthLibService_Factory() { return new OauthLibService(inject(OauthConfigurationProvider)); }, token: OauthLibService, providedIn: "root" });
    return OauthLibService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/oauth-lib.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var OauthLibComponent = /** @class */ (function () {
    function OauthLibComponent() {
    }
    /**
     * @return {?}
     */
    OauthLibComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    OauthLibComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ilp-oauth-lib',
                    template: "\n    <p>\n      oauth-lib works!\n    </p>\n  "
                }] }
    ];
    /** @nocollapse */
    OauthLibComponent.ctorParameters = function () { return []; };
    return OauthLibComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/component/login/oauth-login.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var OauthLoginComponent = /** @class */ (function () {
    function OauthLoginComponent(router, oauthLibService) {
        this.router = router;
        this.oauthLibService = oauthLibService;
        this.loginButtonLabel = 'login';
    }
    /**
     * @return {?}
     */
    OauthLoginComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @return {?}
     */
    OauthLoginComponent.prototype.onLoginClick = /**
     * @return {?}
     */
    function () {
        this.oauthLibService.startAuthentication();
    };
    OauthLoginComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ilp-oauth-login',
                    template: "<div class=\"hd--login-layout\" fxLayout fxLayoutAlign=\"center center\">\n    <div fxFlex=\"50%\">\n        <div fxLayout=\"column\">\n\n            <div fxFlex *ngIf=\"logoURL\">\n                <img class=\"hd--login-logo\" [src]=\"logoURL\">\n            </div>\n\n            <div fxFlex *ngIf=\"title\">\n                <h1 class=\"mat-typography\">{{title}}</h1>\n            </div>\n\n            <div fxFlex>\n                <button class=\"hd--login-button\" (click)=\"onLoginClick()\" mat-raised-button color=\"primary\">{{loginButtonLabel}}\n                </button>\n            </div>\n\n            <div fxFlex fxFlexAlign=\"center\" class=\"hd--logout-info\" *ngIf=\"logoutReason\">\n                <mat-card class=\"mat-card-notification\">\n                    <mat-card-content>\n                        <div fxLayout fxLayoutAlign=\"center center\">\n                            <p class=\"mat-typography hd--notification-message\">{{logoutReason}}</p>\n                        </div>\n                    </mat-card-content>\n                </mat-card>\n            </div>\n\n        </div>\n    </div>\n</div>\n\n",
                    styles: [".hd--login-layout{width:100%;height:100%}.hd--login-layout>div{text-align:center}.hd--login-layout .hd--login-logo{width:100%;max-width:500px;margin-bottom:2rem}.hd--login-layout .hd--login-button{color:#fff;min-width:120px;min-height:50px}.hd--login-layout .hd--logout-info{width:50%}.mat-card-notification{margin:2rem 0 .5rem;padding:6px}.mat-card-notification .hd--notification-message{margin:0}.mat-card-notification .hd--notification-icon{text-align:center}.mat-card-notification .close-icon:hover{cursor:pointer}"]
                }] }
    ];
    /** @nocollapse */
    OauthLoginComponent.ctorParameters = function () { return [
        { type: Router },
        { type: OauthLibService }
    ]; };
    OauthLoginComponent.propDecorators = {
        logoURL: [{ type: Input }],
        logoutReason: [{ type: Input }],
        title: [{ type: Input }],
        loginButtonLabel: [{ type: Input }]
    };
    return OauthLoginComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/oauth-lib.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var OauthLibModule = /** @class */ (function () {
    function OauthLibModule() {
    }
    /**
     * @param {?=} oauthConfiguration
     * @return {?}
     */
    OauthLibModule.forRoot = /**
     * @param {?=} oauthConfiguration
     * @return {?}
     */
    function (oauthConfiguration) {
        if (oauthConfiguration === void 0) { oauthConfiguration = {}; }
        return {
            ngModule: OauthLibModule,
            providers: [
                oauthConfiguration.config || {
                    provide: OauthConfigurationProvider,
                    useClass: DefaultOauthConfiguration
                }
            ]
        };
    };
    OauthLibModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [OauthLibComponent, OauthLoginComponent],
                    imports: [CommonModule, MatCardModule, MatButtonModule, FlexLayoutModule],
                    exports: [OauthLibComponent, OauthLoginComponent]
                },] }
    ];
    return OauthLibModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/oauth-lib.models.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: oauth-lib.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { OauthLibConfiguration, OauthConfigurationProvider, DefaultOauthConfiguration, OauthConfiguration, OauthLibService, OauthLibComponent, OauthLibModule, OauthLoginComponent };

//# sourceMappingURL=oauth-lib.js.map